import { render, staticRenderFns } from "./SelectedCom.vue?vue&type=template&id=42006674&scoped=true"
import script from "./SelectedCom.vue?vue&type=script&lang=js"
export * from "./SelectedCom.vue?vue&type=script&lang=js"
import style0 from "./SelectedCom.vue?vue&type=style&index=0&id=42006674&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42006674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42006674')) {
      api.createRecord('42006674', component.options)
    } else {
      api.reload('42006674', component.options)
    }
    module.hot.accept("./SelectedCom.vue?vue&type=template&id=42006674&scoped=true", function () {
      api.rerender('42006674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base-com/select/components/SelectedCom.vue"
export default component.exports